import Vue from 'vue'
import Vuex from 'vuex'
import countries from './modules/countries'
import cover from './modules/cover'
import coverlate from './modules/coverlate'
import global from './modules/global'
import listcovertabs from './modules/listcovertabs'
import coveractivated from './modules/coveractivated'
import userdetails from './modules/userdetails'
import accounts from './modules/accounts'
import newcover from './modules/newcover'
import coverquoted from './modules/coverquoted'
import siteconfig from './modules/siteconfig'
import coversettled from './modules/coversettled'
import covertimebarred from './modules/covertimebarred'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    countries,
    cover,
    coverlate,
    global,
    listcovertabs,
    coveractivated,
    userdetails,
    accounts,
    newcover,
    coverquoted,
    siteconfig,
    coversettled,
    covertimebarred
  }
})
